import FilterSelect from '@Components/Filter/Dropdown';
import { RootStateType } from '@Store';
import DateRangePicker from '../../components/DateRangePicker';

import { Box } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// import DownloadButton from './DownlaodButton';
import TrackingGraph from './TrackingGraph';
import TrackingTable, { Shipment } from './TrackingTable';
import API from '@Services/apiAxios';
import { ActionPending, ApiResponseTracking } from './types/type';

const TrackingStatus = () => {
  const [system, setSystem] = useState<string[]>([]);
  const { loggedInUserSystemDropdownList } = useSelector((state: RootStateType) => state.System);
  const [dateRange, setDateRange] = useState({
    startDate: moment().subtract(1, 'months').startOf('day').toDate(),
    endDate: moment().endOf('day').toDate(),
  });
  const [trackingStatus, setTrackingStatus] = useState<ApiResponseTracking | null>(null);
  const onSystemFilter = (selected: Array<string>) => {
    setSystem(selected);
  };
  const onDateChange = ({ startDate, endDate }: { startDate: Date; endDate: Date }, isOpen: boolean) => {
    if (isOpen) return;
    const dateRange = { startDate, endDate };
    setDateRange(dateRange);
  };

  const fetchDataForTrackingStatus = async () => {
    try {
      const resp = await API.get('/analytics/shipment/general', {
        params: {
          'system[]': system,
          startDate: dateRange.startDate,
          endDate: dateRange.endDate,
        },
      });
      setTrackingStatus(resp.data);
    } catch (error) {
      console.error('Error in fetching data for customers', error);
    }
  };

  useEffect(() => {
    fetchDataForTrackingStatus();
  }, [system, dateRange]);

  // console.info('trackingStatus', trackingStatus?.data);
  const mapToShipments = (actionPending: ActionPending[]): Shipment[] => {
    return actionPending?.map(item => ({
      id: item?.shipmentNumber,
      status: item?.status,
      statusLabel: item?.statusLabel,
      account: item?._userId.companyName || item?._userId.name, // Use companyName or username if companyName is empty
      accountId: item?._userId.accountNumber || item?._userId.accountNumber, // Use companyName or username if companyName is empty
    }));
  };

  // const mapToTrackingData = (trackingData: TrackingData[]): TrackingData => {
  //   return {
  //     labels: trackingData.labels,
  //     data: trackingData.data,
  //     backgroundColor: trackingData.backgroundColor,
  //   };
  // };
  return (
    <Box
      sx={{
        borderRadius: { xs: '12px', sm: '14px' },
        border: '1px solid #F1F1F1',
        boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: {
          xs: '24px',
          sm: '32px',
          md: '40px',
        },
        padding: {
          xs: '16px',
          sm: '20px',
          md: '28px',
          lg: '40px',
        },
        overflow: 'hidden',
      }}
    >
      {/* Filters */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: {
            xs: 'column',
            sm: 'column',
            md: 'row',
          },

          justifyContent: {
            xs: 'stretch',
            md: 'flex-end', // 👈 right align on medium & large screens
          },

          alignItems: {
            xs: 'stretch',
            md: 'center',
          },

          gap: {
            xs: 2,
            sm: 2,
            md: 2,
          },

          flexWrap: 'wrap',
          width: '100%',
        }}
      >
        {/* System Filter */}
        <Box
          sx={{
            width: {
              xs: '100%',
              sm: '100%',
              md: '240px',
              lg: '240px',
            },
            minWidth: 0,
          }}
        >
          <FilterSelect
            id="system"
            label="Select system"
            options={loggedInUserSystemDropdownList}
            value={system}
            onChange={onSystemFilter}
          />
        </Box>

        {/* Date Range Picker */}
        <Box
          sx={{
            width: {
              xs: '100%',
              sm: '100%',
              md: '240px',
              lg: '240px',
            },
            minWidth: 0,
          }}
        >
          <DateRangePicker onChange={onDateChange} value={dateRange} />
        </Box>
      </Box>

      {/* Content */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: {
            xs: 'column',
            lg: 'row',
          },
          gap: {
            xs: 3,
            sm: 4,
            md: 5,
          },
          width: '100%',
          alignItems: 'stretch',
        }}
      >
        {/* Graph Section */}
        <Box
          sx={{
            flex: 1,
            width: '100%',
            minWidth: 0,
          }}
        >
          <TrackingGraph
            shipmentPercentage={trackingStatus?.data?.shipmentPercentage}
            trackingData={trackingStatus?.data?.trackingData}
          />
        </Box>

        {/* Table Section */}
        <Box
          sx={{
            flex: 1,
            width: '100%',
            minWidth: 0,

            borderLeft: {
              xs: 'none',
              lg: '1px dashed rgba(189, 189, 189, 1)',
            },

            borderTop: {
              xs: '1px dashed rgba(189, 189, 189, 1)',
              lg: 'none',
            },

            paddingLeft: {
              xs: 0,
              lg: '32px',
              xl: '40px',
            },

            paddingTop: {
              xs: '24px',
              lg: 0,
            },

            overflow: 'hidden',
          }}
        >
          <TrackingTable
            shipments={trackingStatus?.data.actionPending && mapToShipments(trackingStatus?.data.actionPending)}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default TrackingStatus;
